
import { Component, Inject, Vue } from 'vue-property-decorator';
import LoadingIndicator from '../../core/components/Generics/LoadingIndicator.vue';
import ClaimDetailView from './components/ClaimDetailView.vue';
import { ClaimDetailResponse, ClaimManagementPort } from '../../core/api/ports';
import { InjectionKey } from '../../core/injection-keys';
import { NAME_ROUTES } from '../../core/utils/name-routes';

@Component({
    components: {
        LoadingIndicator,
        ClaimDetailView
    }
})
export default class PageClaimDetail extends Vue {
    @Inject(InjectionKey.ClaimManagementApi) readonly claimsApi!: ClaimManagementPort;
    pendingInfo: boolean = false;
    errorDetail: boolean = false;
    claimDetail: ClaimDetailResponse | null = null;

    async created(){
        // Load properties first (for translations)
        await this.loadProperties();
        // Then load claim detail
        this.getClaimDetail();
    }

    async loadProperties(){
        try {
            await this.$store.dispatch('properties/loadProperties');
        } catch (error) {
            console.error('Error loading properties:', error);
        }
    }

    getClaimDetail(liftOriginalPolygonRestriction: boolean = false){
        const claimId = parseInt(this.$route.params.id);

        if (!claimId) {
            this.errorDetail = true;
            return;
        }

        this.errorDetail = false;
        this.pendingInfo = true;

        this.claimsApi.getClaimDetail(claimId)
        .then((response: ClaimDetailResponse) => {
            this.claimDetail = liftOriginalPolygonRestriction
                ? { ...response, using_original_polygon: false }
                : response;
        }).catch((error) => {
            console.error('Error fetching claim detail:', error);
            this.errorDetail = true;
            this.claimDetail = null;
        }).finally(() => {
            this.pendingInfo = false;
        })
    }

    goBack(){
        this.$router.push({ name: NAME_ROUTES.CLAIMS_LIST.name });
    }
}
